module.exports = __webpack_public_path__ + "static/gallery10-f1341854ca692a23e720ee9d3f3dfefc.png";